import { render, staticRenderFns } from "./DevelopmentKPI.vue?vue&type=template&id=b5e61dbc&scoped=true"
import script from "./DevelopmentKPI.vue?vue&type=script&lang=js"
export * from "./DevelopmentKPI.vue?vue&type=script&lang=js"
import style0 from "./DevelopmentKPI.vue?vue&type=style&index=0&id=b5e61dbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e61dbc",
  null
  
)

export default component.exports